module.exports = __webpack_public_path__ + "static/media/load-white.0a80227e.svg";